import React from 'react'
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const Privateroutes = ({ allowedRoles }) => {
 

const isAuthenticated = useSelector((state) => state.myreducer.isAuthenticated)
const userRole = useSelector((state) => state.myreducer.userRole);

if (!isAuthenticated || !userRole) {
  return null; 
}

  if (!allowedRoles || allowedRoles.includes(userRole)) {
    return <Outlet />;
  } else {
    return <Navigate to="/registration" />;
  }


}

export default Privateroutes